// Product database with real affiliate links
export const products = [
  {
    id: 'femipro',
    name: 'FemiPro',
    shortDescription: 'Comprehensive menopause support formula',
    description: 'FemiPro is a comprehensive menopause support formula targeting multiple symptoms including hot flashes, mood balance, and hormonal health. This science-backed supplement combines natural ingredients to provide relief from the most common menopause challenges.',
    benefits: [
      'Reduces hot flashes and night sweats',
      'Supports healthy hormonal balance',
      'Improves mood and emotional wellbeing',
      'Enhances sleep quality',
      'Boosts energy levels'
    ],
    link: 'https://c84021o52danax0enhpj3c5p1a.hop.clickbank.net/?&traffic_source=google&traffic_type=organic&campaign=getmenomatch&creative=banner&ad=FemiPro',
    platform: 'ClickBank',
    targetSymptoms: ['hotFlashes', 'mood', 'sleep', 'energy'],
    category: 'comprehensive',
    price: '$$$',
    rating: 4.5
  },
  {
    id: 'cellucare',
    name: 'CelluCare',
    shortDescription: 'Advanced cellular support supplement',
    description: 'CelluCare is an advanced cellular support supplement designed to boost energy and overall wellness during menopause. It works at the cellular level to enhance vitality and reduce fatigue.',
    benefits: [
      'Increases energy levels naturally',
      'Supports cellular health and regeneration',
      'Reduces chronic fatigue',
      'Enhances overall vitality',
      'Supports metabolic function'
    ],
    link: 'https://cellucarehq.com/d/order-now.php#aff=SaraMagalhaes',
    platform: 'Direct',
    targetSymptoms: ['energy', 'weight', 'mood'],
    category: 'energy',
    price: '$$',
    rating: 4.3
  },
  {
    id: 'black-cohosh',
    name: 'Black Cohosh Complex',
    shortDescription: 'Natural herbal supplement for hot flashes',
    description: 'Black Cohosh Complex is a natural herbal supplement specifically formulated to reduce hot flashes and night sweats. This time-tested botanical remedy has been used for generations to support women during menopause.',
    benefits: [
      'Clinically proven to reduce hot flashes',
      'Minimizes night sweats',
      '100% natural plant-based ingredients',
      'Hormone-free alternative',
      'No artificial additives'
    ],
    link: 'https://amzn.to/46T3oFH',
    platform: 'Amazon',
    targetSymptoms: ['hotFlashes', 'sleep'],
    category: 'hot-flashes',
    price: '$',
    rating: 4.4
  },
  {
    id: 'ashwagandha-magnesium',
    name: 'Ashwagandha & Magnesium Complex',
    shortDescription: 'Stress relief and mood support',
    description: 'A powerful combination of Ashwagandha and Magnesium for stress relief, mood support, and better sleep quality. This synergistic formula addresses the emotional and mental challenges of menopause.',
    benefits: [
      'Reduces anxiety and stress naturally',
      'Improves mood stability',
      'Promotes better sleep quality',
      'Supports cognitive function',
      'Enhances relaxation'
    ],
    link: 'https://amzn.to/4o18xBO',
    platform: 'Amazon',
    targetSymptoms: ['mood', 'sleep', 'memory'],
    category: 'mood-sleep',
    price: '$',
    rating: 4.6
  },
  {
    id: 'collagen-beauty',
    name: 'Collagen Beauty Blend',
    shortDescription: 'Premium collagen for skin, hair & joints',
    description: 'Premium collagen supplement designed for skin elasticity, hair health, and joint support. As estrogen declines during menopause, collagen production decreases - this supplement helps maintain healthy levels.',
    benefits: [
      'Improves skin elasticity and hydration',
      'Strengthens hair and reduces hair loss',
      'Supports nail health and growth',
      'Relieves joint pain and stiffness',
      'Anti-aging benefits from within'
    ],
    link: 'https://amzn.to/47qdNst',
    platform: 'Amazon',
    targetSymptoms: ['skin', 'joints'],
    category: 'beauty',
    price: '$$',
    rating: 4.7
  },
  {
    id: 'sleep-support',
    name: 'Sleep Support Formula',
    shortDescription: 'Natural sleep aid for restful nights',
    description: 'Natural sleep aid combining melatonin, valerian root, and calming herbs for restful nights. This non-habit forming formula helps you fall asleep faster and stay asleep longer.',
    benefits: [
      'Promotes deep, restorative sleep',
      'Reduces insomnia and sleep disruptions',
      'Natural, plant-based ingredients',
      'Non-habit forming formula',
      'Wake up feeling refreshed'
    ],
    link: 'https://amzn.to/496okud',
    platform: 'Amazon',
    targetSymptoms: ['sleep', 'mood', 'energy'],
    category: 'sleep',
    price: '$',
    rating: 4.5
  },
  {
    id: 'metabolism-support',
    name: 'Metabolism Support Complex',
    shortDescription: 'Weight management during menopause',
    description: 'Helps maintain healthy weight and metabolism during hormonal changes. This formula supports your body\'s natural fat-burning processes and helps combat menopausal weight gain.',
    benefits: [
      'Supports healthy metabolism',
      'Aids in weight management',
      'Boosts natural energy levels',
      'Natural thermogenic ingredients',
      'Helps reduce belly fat'
    ],
    link: 'https://amzn.to/3WFJfwJ',
    platform: 'Amazon',
    targetSymptoms: ['weight', 'energy'],
    category: 'weight',
    price: '$',
    rating: 4.2
  },
  {
    id: 'maca-root',
    name: 'Maca Root Complex',
    shortDescription: 'Adaptogenic herb for hormonal balance',
    description: 'Traditional adaptogenic herb known for supporting hormonal balance and energy levels. Maca has been used for centuries by women to naturally support their bodies during hormonal transitions.',
    benefits: [
      'Naturally balances hormones',
      'Increases energy and stamina',
      'Reduces fatigue and exhaustion',
      'Supports mood and emotional health',
      'Enhances libido and vitality'
    ],
    link: 'https://amzn.to/4nMbcio',
    platform: 'Amazon',
    targetSymptoms: ['energy', 'mood', 'hotFlashes'],
    category: 'hormonal',
    price: '$',
    rating: 4.4
  },
  {
    id: 'red-clover',
    name: 'Red Clover Extract',
    shortDescription: 'Natural phytoestrogen supplement',
    description: 'Natural phytoestrogen supplement for managing menopausal symptoms. Red clover contains isoflavones that mimic estrogen in the body, providing gentle relief from hot flashes and other symptoms.',
    benefits: [
      'Reduces frequency of hot flashes',
      'Supports bone health naturally',
      'Gentle, natural approach',
      'Plant-based phytoestrogens',
      'Cardiovascular health support'
    ],
    link: 'https://amzn.to/47b9Er6',
    platform: 'Amazon',
    targetSymptoms: ['hotFlashes', 'joints'],
    category: 'hormonal',
    price: '$',
    rating: 4.3
  },
  {
    id: 'caldwell-program',
    name: 'Claudia Caldwell Menopause Program',
    shortDescription: 'Complete wellness program by expert',
    description: 'Comprehensive wellness program designed by menopause expert Claudia Caldwell for complete menopause management. This program combines education, nutrition, exercise, and lifestyle strategies for holistic relief.',
    benefits: [
      'Expert-led comprehensive program',
      'Holistic mind-body approach',
      'Proven strategies and results',
      'Supportive community access',
      'Lifetime program access'
    ],
    link: 'https://www.claudiacaldwell.com/oto-uf61a?el=splittest-1214-bradflow-control#aff=SaraMagalhaes',
    platform: 'Digistore24',
    targetSymptoms: ['hotFlashes', 'mood', 'weight', 'sleep'],
    category: 'program',
    price: '$$$',
    rating: 4.8
  },
  {
    id: 'wellness-bundle',
    name: 'Complete Menopause Wellness Bundle',
    shortDescription: 'All-in-one solution bundle',
    description: 'All-in-one solution combining nutrition guides, exercise plans, and supplement guidance. This comprehensive bundle gives you everything you need to manage menopause symptoms naturally and effectively.',
    benefits: [
      'Complete system approach',
      'Personalized diet plans',
      'Exercise routines for menopause',
      'Supplement guide included',
      'Lifestyle optimization tips'
    ],
    link: 'https://www.digistore24.com/redir/562310/SaraMagalhaes/',
    platform: 'Digistore24',
    targetSymptoms: ['weight', 'energy', 'mood', 'sleep'],
    category: 'program',
    price: '$$$',
    rating: 4.6
  },
  {
    id: 'hormone-balance',
    name: 'Natural Hormone Balance Guide',
    shortDescription: 'Digital guide for hormone health',
    description: 'Comprehensive digital guide to naturally balance hormones during menopause. Learn evidence-based strategies to support your body through this transition without harsh medications.',
    benefits: [
      'Evidence-based strategies',
      'Natural hormone support',
      'Easy to follow protocols',
      'Digital access anywhere',
      'Money-back guarantee'
    ],
    link: 'https://www.digistore24.com/redir/472943/SaraMagalhaes/',
    platform: 'Digistore24',
    targetSymptoms: ['hotFlashes', 'mood', 'energy'],
    category: 'education',
    price: '$$',
    rating: 4.5
  }
];

export default products;
